import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

const FeaturedItem = ({ title, image, linkUrl }) => {

  const Container = styled.div`
  padding: 1rem;
  text-align: center;
  
  figure {
    margin: 0;
    width: 100%;
  }
  a {
    text-decoration: none;

    h2 {
      text-transform: uppercase;
      color: var(--brand-color-white);
      margin: 0;
      padding-top: 0;
    }
  }
  `;
  
  return (
    <Container className="pure-u-1-2 pure-u">
      <Link to={linkUrl}>
        <h2>{title}</h2>
        {image}
      </Link>
    </Container>
  )
}

export default FeaturedItem
